var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUtensils(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "utensils"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.25 1.4994V6.74982C2.25 7.57489 2.925 8.24994 3.75 8.24994H6.75C7.14782 8.24994 7.52936 8.09189 7.81066 7.81056C8.09196 7.52924 8.25 7.14768 8.25 6.74982V1.4994M5.25 1.4994V16.5006M15.75 11.2502V1.4994C14.7554 1.4994 13.8016 1.89452 13.0983 2.59784C12.3951 3.30116 12 4.25506 12 5.2497V9.75006C12 10.5751 12.675 11.2502 13.5 11.2502H15.75ZM15.75 11.2502V16.5006",
    stroke: "#475569",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtensils);
export default __webpack_public_path__ + "static/media/utensils.ceeba53b372661aa4ab1bbe620bfbe4e.svg";
export { ForwardRef as ReactComponent };